import { useAtomValue } from 'jotai';
import { IndexUiState } from 'instantsearch.js';
import { currentContextAtom } from '../state';

export interface UseDiscoveryDefaultRefinementsProps {
  initialIndexUiState : IndexUiState;
  isScopeFilterDisplayed: boolean;
  isDeliveryFilterDisplayed: boolean;
}

export default function useDiscoveryDefaultRefinements({ initialIndexUiState, isScopeFilterDisplayed, isDeliveryFilterDisplayed } : UseDiscoveryDefaultRefinementsProps): IndexUiState | undefined {
  const { deliveryZones, userBrands, userAdministrativeAreas } = useAtomValue(currentContextAtom);

  const brandsFilter: string[] = [];
  const administrativeAreasFilter: string[] = [];

  const areaFilterValue = (area: string): string => {
    return `administrative_area_level_2|${area!}`;
  };

  if (initialIndexUiState) {
    return;
  }

  if (isScopeFilterDisplayed) {
    userBrands?.forEach(({ brand, has_all_brands }) => {
      if (!has_all_brands) {
        brandsFilter.push(brand!);
      }
    });

    userAdministrativeAreas?.forEach(({ area, has_all_areas }) => {
      if (!has_all_areas) {
        administrativeAreasFilter.push(areaFilterValue(area!));
      }
    });
  }

  if (isDeliveryFilterDisplayed) {
    deliveryZones?.forEach(({ administrative_areas }) => {
      administrative_areas?.forEach(({ area }) => {
        if (!administrativeAreasFilter.includes(area)) {
          administrativeAreasFilter.push(areaFilterValue(area));
        }
      });
    });
  }

  return {
    refinementList: {
      brand: brandsFilter,
      administrative_areas: administrativeAreasFilter,
    },
  };
}
